// extracted by mini-css-extract-plugin
export default {"segment-counter":"segment-counter--6WCzMfgGWo","segmentCounter":"segment-counter--6WCzMfgGWo","exceeded":"exceeded--L3Cgi59Gcj"};